// A aba do aparelho (nexus-wa) em Configurações → Caixas de entrada → a caixa.
// Entra no Settings.vue do core por um patch (custom/docs/PATCHES.md):
// - caixa não oficial: "Aparelho" (sempre: sem aparelho ela não funciona);
// - caixa da API oficial: "Caixa híbrida", com o recurso whatsapp_nao_oficial.
import { recursosDe } from '../nexus/recursos';
import messages from '../nexus/i18n';

export const ABA_DO_APARELHO = 'neuxs-aparelho';

export const abaDoAparelho = (inbox, accountId) => {
  if (inbox?.channel_type !== 'Channel::Whatsapp') return null;
  const textos = messages.pt_BR.NEUXS_NEXUS.WHATSAPP;
  if (inbox.provider === 'nexus_wa') {
    return { key: ABA_DO_APARELHO, name: textos.ABA_APARELHO };
  }
  if (inbox.provider === 'whatsapp_cloud' && recursosDe(accountId)?.whatsapp) {
    return { key: ABA_DO_APARELHO, name: textos.ABA_HIBRIDA };
  }
  return null;
};
